export default __webpack_public_path__ + "static/media/FoodChainDesert_06.05428536.png";